import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";
import Detailpage from "../DetailPage";
import {Modal, Button, Empty} from 'antd';
import {unitConvert} from "../../../../utils";

export default class RelatedResources extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            tabList: [{
                id: '1',
                name: '稿件'
            }, {
                id: '2',
                name: '图片'
            }, {
                id: '3',
                name: '音频'
            }, {
                id: '4',
                name: '视频'
            }, {
                id: '5',
                name: '文件'
            }],
            thisTabKey: '1',
            page: 1,
            size: 10,
            relatedFileList:[],
            currentIndex:0,
            virtualFileId:this.props.virtualFileId

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getFile()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.virtualFileId!=this.state.virtualFileId){
            // this.state.virtualFileId=nextProps.virtualFileId;
            this.setState({},()=>{
                this.getFile()
            })
        }

    }


    render() {
        let {relatedFileList} = this.state;
        return (
            <>
                {
                    relatedFileList && relatedFileList.length > 0 ?
                            relatedFileList.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div style={{
                                            display: 'flex',
                                            padding: '12px  0',
                                            margin: '0 16px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.15)'
                                        }}
                                             onClick={() => {
                                                 this.itemClick(item, index)
                                             }}>

                                            <div style={{marginRight: '10px'}}>
                                                <Titlepicfile src={item.icon}
                                                              style={{
                                                                  width: '88px',
                                                                  height: '88px',
                                                                  borderRadius: '10px',
                                                                  overflow: 'hidden'
                                                              }}/>
                                            </div>
                                            <div
                                                style={{
                                                    flexGrow: '1',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center'
                                                }}>
                                                <div style={{
                                                    width: '223px',
                                                    fontSize: '16px',
                                                    color: 'rgba(0, 0, 0, 0.85)',
                                                }}>{item.name}</div>
                                                <div style={{
                                                    fontSize: '14px',
                                                    color: 'rgba(0, 0, 0, 0.65)',
                                                    margin: '4px 0'
                                                }}>{unitConvert(item.size)}</div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontSize: '12px',
                                                    color: 'rgba(0, 0, 0, 0.45)'
                                                }}>
                                                    <span>途径：{item.extendedAttributeJson.source}</span>
                                                    <span>{moment(item.updateTime).format('YYYY-MM-DD')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        {/*相关资源弹框*/}
                                        <Detailpage onRef={(Detailpage) => this.setDetailpage = Detailpage}
                                                    dataList={relatedFileList}></Detailpage>
                                    </div>
                                )
                            }):<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{marginTop: 240}}/>

                }
            </>
        )
    }
    //相关资源
    getFile(){
        this.request({
            url: '/cm-sites-storage-management/zykFile/getRelatedFileList',
            method: 'post',
            body: {
                page: 1,
                size: 10,
                virtualFileId: this.props.virtualFileId
            },
            contentType: "json",
            callBack: (data) => {
                let relatedFileList = [];
                if (data) {
                    relatedFileList = data.data
                }
                this.setState({relatedFileList})
                this.setState({})
            }
        });
    }


    itemClick(item,index){
        this.setDetailpage.show(true, item,index)
    }


}